import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Solutionpoint() {
  return (
    <section
      className="solution_point p-100 text_white bg_green_color"
      style={{ background: "#000" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              Solutions <span style={{ color: "#E8E751" }}>Delivered</span>
            </h2>
            <p>
              To meet the project's objectives based on the client's idea and
              address the challenges, TekRevol delivered a tailored solution in
              the shape of an iOS application. We built a full-fledged app that
              provides celebrities with a user-friendly interface for adding
              digital signatures to their orders. This mobile app serves as the
              primary tool for enhancing the order management process.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center offset-xl-1 offset-lg-1"
          >
            <div className="banner_img">
              <StaticImage
                src="../../../images/case-studies/point2-design/solution_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={791}
                height={752}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Solutionpoint;
